import styled, { css } from 'styled-components';
import { Colors, FInter, FlexBox } from '@brg/ui';
import { IActively } from '@brg/toolbox';
import { CoreContainer, LayoutConst } from '../../../core';
import { CustomHollowButton, RectangularButtonFilled, RectangularButtonHollow } from 'shared/components/buttons';

export const DesignerEditWrapper = styled(CoreContainer)`
    display: flex;
    margin: 0 auto;
    margin-bottom: 40px;
    justify-content: space-between;
`;

export const DesignerEditContainer = styled(FlexBox)`
    flex-direction: column;
    width: 954px;

    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        width: 710px;
    }

    .white_theme_project_underline {
        font-size: 23px;
        line-height: 29px;

        @media(max-width: ${LayoutConst.screen.md}px) {
            font-size: 20px;
            line-height: 25px;
        }

        @media(max-width: ${LayoutConst.screen.s -1}px) {
            font-size: 15px;
            line-height: 20px;
        }
    }
`;

export const DesignerEditSection = styled(FlexBox)`
    flex-direction: column;
`;

export const MainSectionTitle = styled(FInter.MainTitleMedium)`
    margin-top: 56px;
    padding-bottom: 11px;
    font-size: 60px;
    line-height: 70px;
    white-space: pre;
    // border-bottom: 1px solid ${Colors.geoWhite21};
    color: ${(p) => p.theme.designerEdit.mainTitle.color};
    margin-bottom: 21px;

    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 51px;
        line-height: 60px;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        font-size: 34px;
        line-height: 41px;
    }

`

export const GoButtonWrapper = styled(FlexBox)`
    place-items: baseline;
    &:hover {
        span {
            color: ${p => p?.theme.designerEdit.icons.colorHover};
            transition: 0.2s color;
        }
        svg path {
            fill: ${p => p?.theme.designerEdit.icons.colorHover};
            transition: 0.2s fill;
        }
    }
`;

export const DesignerEditSectionTitle = styled(FInter.SectionTitleSubtitleBoldDiv)`
    font-size: 23px;
    line-height: 29px;
    margin-top: 40px;
    color: ${(p) => p.theme.designerEdit.editTitle.secondColor};
    margin-bottom: 24px;
    font-weight: 500;

    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        margin-top: 40px;
        margin-bottom: 5px;
        font-weight: 500;
        font-size: 22px;
        line-height: 28px;
    }
`;

export const DesignerEditSectionSubTitle = styled(FInter.SmallTextDiv)`
    padding-bottom: 11px;
    color: ${(p) => p.theme.designerEdit.inputs.labelColor};
    margin-bottom: 16px;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
`;

export const DesignerInputGrid = styled(FlexBox)`
    flex-direction: column;
`;

export const DesignerInputGridRow = styled(FlexBox)<{gradientNeed?: boolean, blackBG?: boolean}>`
    position: relative;
    align-items: center;
    
    &.country {
        flex-direction: column;
    }

    & + & {
        margin-top: 24px;
    }

    #account-id-input {
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &:after {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 2px;
        width: 97px;
        z-index: 2;
        height: 45px;
        background: ${p => p?.blackBG ? 'linear-gradient(270deg, rgba(197,198,199,0.9) 55% , rgba(197,198,199,0) 100%);' : 'linear-gradient(270deg, rgba(242,242,242,0.9) 55.21%, rgba(242, 242, 242, 0) 100%);'};
        display: ${p => p?.gradientNeed ? 'inline-block': 'none'};
    }

    @media(max-width: ${LayoutConst.screen.s -1 }px) {
        height: auto;
        & + & {
            margin-top: 16px;
        }
    
    }
`;

export const CountriesListDropdown = styled.div< {isGeograffee?: boolean}>`
  display: flex;
  flex-direction: column;
  max-height: 184px;
  width: calc(100% - 174px - 24px);
  right: 0;
  top: calc(100% - 1px);
  z-index: 10000;
//   border-bottom: 1px solid #fefefe;
  box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.12);
  background: ${({ isGeograffee }) => (isGeograffee ? '#3F4548' : '#F2F2F2')};  
  overflow-y: auto;
  color: ${({ isGeograffee }) => (isGeograffee ? '#ABAEAF' : '#000')};
//   height: 184px;
  height: fit-content;
  position: absolute;

  &:hover{
  }

  &::-webkit-scrollbar {
    width: 6px; /* ширина scrollbar */
    height: 10px;
  }
  &::-webkit-scrollbar-track {
    background: ${({ isGeograffee }) => (isGeograffee ? '#3F4548' : '#CDCDCD')};  /* цвет дорожки */
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 3px; /* закругления плашки */
    background: #909090;
  }
  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    top: calc(100% - 8px);
    width: calc(100% - 174px - 4px);
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    top: 100%;
    width: 100%;
  }
`

export const CountryItem = styled.div< {isGeograffee?: boolean}>`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
  font-size: 17px;
  line-height: 22px;
  font-weight: 600;
//   background: #F2F2F2;
  padding: 12px 16px;
  cursor: pointer;
  img {
    width: 24px;
    height: 15px;
  }
  @media (max-width: 1200px) {
    font-size: 15px;
    line-height: 20px;
    padding: 8px 16px;
  }
  &:hover {
        background: ${({ isGeograffee }) => (isGeograffee ? '#575B5E' : '#ededed')};  
        color: ${({ isGeograffee }) => (isGeograffee ? '#ABAEAF' : '#000')};
  }
`

export const CopyIconWrapper = styled(FlexBox)`
    position: absolute;
    top:50%;
    transform: translateY(-50%);
    right: 16px;
    z-index: 3;
    width: 97px;
    justify-content: flex-end;
    // &:hover {
    //     svg path {
    //         fill: ${p => p?.theme.designerEdit.icons.colorHover};
    //         transition: 0.2s fill;
    //     }
    // }
`;

export const ShareIconWrapper = styled(FlexBox)`
    position: absolute;
    bottom: 16px;
    right: 16px;

    &:hover {
        svg path {
            fill: ${p => p?.theme.designerEdit.icons.colorHover};
            transition: 0.2s fill;
        }
    }
`;

export const PasswordChangeLabel = styled(FlexBox)`
    svg {
        height: 20px;
        height: 20px;
    }
`;

export const DesignerInputLabel = styled(FInter.SmallTextDiv)<{ whiteLabel?: boolean, importantColor?: boolean }>`
    font-size: 17px;
    line-height: 22px;
    width: 174px;
    min-width: 174px;
    margin-right: 24px;
    color: ${(p) => p?.whiteLabel ? p.theme.designerEdit.inputs.whiteLabelColor: p.theme.designerEdit.inputs.labelColor};


    ${p => p.importantColor ? css`
    color: ${(p) => p.theme.designerEdit.inputs.importantColor};
    ` : null}

    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        width: 154px;
        min-width: 154px;
        font-size: 15px;
        line-height: 20px;
    }

    @media(max-width: ${LayoutConst.screen.s -1 }px) {
        width: calc(100% - 20px);
        min-width: calc(100% - 20px);
        margin-bottom: 12px;
    }
`;


export const AvatarLabel = styled(FlexBox)`
    width: 174px;
    min-width: 174px;
    margin-right: 24px;

    ${DesignerInputLabel} {
        font-size: 17px;
        line-height: 22px;
    }

    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        width: 154px;
        min-width: 154px;

        ${DesignerInputLabel} {
            font-size: 15px;
            line-height: 20px;
        }
    }
`;

export const DesignerResizeBlock = styled.div<{ withoutBorder?: boolean, col?: boolean }>`
    display: flex;
    flex-flow: ${({ col }) => col ? 'column' : 'row'};
    margin-top: 24px;
    place-items: baseline;

    textarea {
        max-height: 500px;
        width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.s -1 }px) {
        margin-top: 16px;
    }
`;
 
export const DesignerEditAboutProfile = styled(FlexBox)`
    /* background-color: #262c30; */
    background: ${(p) => p.theme.designerEdit.aboutProfile.bg};
    padding: 24px;
    border-radius: 8px;
    width: 560px;
`;

export const DesignerMergeAccounts = styled(FlexBox)`
    background: ${(p) => p.theme.designerEdit.aboutProfile.bg};
    padding: 14px;
    border-radius: 8px;
    width: 560px;
    flex-direction: column;
`;

/* потом переписать! костыль! */
interface IActiveWhiteTheme extends IActively {
    custom_theme?: boolean;
    white_theme?: boolean;
}

export const DesignerLocalSwitchItem = styled(FInter.TextBoldDiv)<IActiveWhiteTheme>`
    cursor: pointer;
    color: ${(p) =>
        p.active ? p.theme.designerEdit.localSwitch.textColor : p.theme.designerEdit.localSwitch.textColorInactive};
    padding-bottom: ${(p) => (p.active ? 4 : 6)}px;
    border-bottom: ${(p) => (p.active ? `2px solid ${p.theme.designerEdit.localSwitch.borderColor}` : 'none')};

    & + & {
        margin-left: 24px;
    }

    &:hover {
        color: ${(p) =>
            p.active ? p.theme.designerEdit.localSwitch.textColor : p.theme.designerEdit.localSwitch.textColorHover};
    }
`;

export const DesignerSidebarContainer = styled(FlexBox)`
    width: 270px;
    margin-top: 49px;
    position: relative;
`;
export const DesignerSidebarContent = styled(FlexBox)`
    width: 270px;
    flex-direction: column;
    position: fixed;
    top: calc(64px + 49px);
    bottom: 65px;
`;

export const DesignerEditPageLink = styled(FInter.SmallTextBoldFlex)<{ active?: boolean; className?: boolean }>`
    cursor: pointer;
    transition: all 0.2s;

    :hover {
        color: ${(p) => p.theme.designerEdit.pageLink.hoverColor};
    }

    & + & {
        margin-top: 20px;
    }
`;

export const LabelRedStar = styled(FInter.SmallText)<{ hide?: boolean }>`
    font-family: Inter;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -2%;

    margin-left: 4px;
    color: ${Colors.redFailed};

    ${p => p?.hide ? css` opacity: 0;` : null};
`;

export const LabelBigRedStar = styled(FInter.SmallText)`
    font-weight: 500;
    color: ${Colors.redFailed};
    position: absolute;
    top: 2px;
    right: -8px;
`;

export const PlaceholderImg = styled.img<any>`
width: ${p => p.width? p.width + 'px' : 'auto'};
height: ${p => p.height? p.height + 'px' : 'auto'};
padding: 5px;
`

export const WordCount = styled(FlexBox)`
    padding-top: 6px;
    width: 100%;
    justify-content: flex-end;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 13px;
    letter-spacing: 0.06em;
    color: ${({ theme }) => theme.designerEdit.inputs.labelColor};
`;

export const DeleteButtonIconWrapper = styled(FlexBox)`
    position: absolute;
    right: 10px;
    top: 10px;
    padding: 6px;
    z-index: 100;
    cursor: pointer;
    border-radius: 20%;

    background: rgba(24, 26, 28, 0.5);
    backdrop-filter: blur(2px);

    svg {
        margin-top: -2px;
    }
`;

export const ProfileTagsWrapper = styled(FlexBox)<{ isGeograffee?: boolean }>`
    color: ${(p) => p.isGeograffee && p.theme.tagItemView.textColor};
`;

export const ProfileTagsLabel = styled(AvatarLabel)``;

export const InputLabel = styled(AvatarLabel)``;

export const ProfileTagsListWrapper = styled(FlexBox)`
    overflow-y: hidden;
    margin: 0;
    width: 100%;
    display: inline-flex;
    flex-wrap: wrap;
    position: relative;

`;

export const ChangePasswordButton = styled.div`
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    color: #E36650;
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    cursor: pointer;

    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media(max-width: ${LayoutConst.screen.s -1 }px) {
        top: auto;
        bottom: 0;
    }
`;

export const ForgetPasswordButton = styled(ChangePasswordButton)`
    bottom: -28px;
    top: auto;
    left: calc(174px + 24px);
    transform: none;

    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        left: calc(154px + 24px);
    }

    @media(max-width: ${LayoutConst.screen.s -1 }px) {
        left: 0px;
    }
`;

export const ButtonFilled = styled(RectangularButtonFilled)<{isLMS?: boolean}>`
    width: 200px;
    height: 38px;
    font-size: 17px;
    line-height: 22px;
    padding: 8px 24px;
    white-space: nowrap;
    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
        height: 36px;
        width: 176px;
        padding: 8px 20px;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        height: 36px !important;
    }

    @media(max-width: ${LayoutConst.screen.s -1 }px) {
        width: ${({isLMS}) => isLMS ? 100 : 65}%;
        min-width: 65%;
        height: 36px !important;
    }
`;

export const QueueButtonFilled = styled(RectangularButtonFilled)<{ hide?: boolean}>`

    ${({ hide }) => hide && css`
        display: none;
    `};
  height: 46px !important;
  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        height: 38px !important;
      font-weight: 700;
    }
    @media(max-width: ${LayoutConst.screen.m}px) {
        height: 36px !important;
    }
    @media(max-width: ${LayoutConst.screen.s -1 }px) {
        margin-top: 24px;
        width: 100%;
        min-width: 100%;
        height: 46px !important;
    }
`;

export const ButtonHollow= styled(RectangularButtonHollow)`
    width: 131px;
    min-width: 131px;
    height: 38px;
    font-size: 17px;
    line-height: 22px;
    padding: 8px 24px;
    white-space: nowrap;
    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 22px;
        height: 36px;
        width: 114px;
        min-width: 114px;
        padding: 8px 20px;
    }
    @media(max-width: ${LayoutConst.screen.m}px) {
        height: 36px !important;
    }

    @media(max-width: ${LayoutConst.screen.s -1 }px) {
        width: 100%;
        min-width: auto;
        height: 36px !important;
    }
`;

export const TwoWindowWrapper = styled.div`
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    // z-index: 1;
    // background-color: ${(p) => p.theme.designerEdit.aboutProfile.bg};
    background-color: transparent;

    @media(max-width: ${LayoutConst.screen.s -1 }px) {
        top: auto;
        transform: none;
        bottom: 12%;
    }
`;

export const SaveButton = styled(RectangularButtonHollow)`
  height: 40px !important;
  min-height: 32px;
  font-weight: 600 !important;
  min-width: auto !important;
  width: 108px !important;
  background-color: ${({ theme }) => theme.modal.buttons.saveButtonBG} !important;
  color: ${({ theme }) => theme.modal.buttons.saveButtonColor} !important;
  padding: 7px 12px 9px 12px;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.01em;
  text-align: left;

`;

export const ExitButton = styled.button`
  height: 40px !important;
  width: 74px;
  padding: 7px 12px 9px 12px;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.01em;
  text-align: left;
  border: none;
`;import styled, { css } from 'styled-components';
import { Colors, FInter, FlexBox } from '@brg/ui';
import { IActively } from '@brg/toolbox';
import { CoreContainer, LayoutConst } from '../../../core';
import { CustomHollowButton, RectangularButtonFilled, RectangularButtonHollow } from 'shared/components/buttons';

export const DesignerEditWrapper = styled(CoreContainer)`
    display: flex;
    margin: 0 auto;
    margin-bottom: 40px;
    justify-content: space-between;
`;

export const DesignerEditContainer = styled(FlexBox)`
    flex-direction: column;
    width: 954px;

    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        width: 710px;
    }

    .white_theme_project_underline {
        font-size: 23px;
        line-height: 29px;

        @media(max-width: ${LayoutConst.screen.md}px) {
            font-size: 20px;
            line-height: 25px;
        }

        @media(max-width: ${LayoutConst.screen.s -1}px) {
            font-size: 15px;
            line-height: 20px;
        }
    }
`;

export const DesignerEditSection = styled(FlexBox)`
    flex-direction: column;
`;

export const MainSectionTitle = styled(FInter.MainTitleMedium)`
    margin-top: 56px;
    padding-bottom: 11px;
    font-size: 60px;
    line-height: 70px;
    white-space: pre;
    // border-bottom: 1px solid ${Colors.geoWhite21};
    color: ${(p) => p.theme.designerEdit.mainTitle.color};
    margin-bottom: 21px;

    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 51px;
        line-height: 60px;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        font-size: 34px;
        line-height: 41px;
    }

`

export const GoButtonWrapper = styled(FlexBox)`
    place-items: baseline;
    &:hover {
        span {
            color: ${p => p?.theme.designerEdit.icons.colorHover};
            transition: 0.2s color;
        }
        svg path {
            fill: ${p => p?.theme.designerEdit.icons.colorHover};
            transition: 0.2s fill;
        }
    }
`;

export const DesignerEditSectionTitle = styled(FInter.SectionTitleSubtitleBoldDiv)`
    font-size: 23px;
    line-height: 29px;
    margin-top: 40px;
    color: ${(p) => p.theme.designerEdit.editTitle.secondColor};
    margin-bottom: 24px;
    font-weight: 500;

    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        margin-top: 40px;
        margin-bottom: 5px;
        font-weight: 500;
        font-size: 22px;
        line-height: 28px;
    }
`;

export const DesignerEditSectionSubTitle = styled(FInter.SmallTextDiv)`
    padding-bottom: 11px;
    color: ${(p) => p.theme.designerEdit.inputs.labelColor};
    margin-bottom: 16px;
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
`;

export const DesignerInputGrid = styled(FlexBox)`
    flex-direction: column;
`;

export const DesignerInputGridRow = styled(FlexBox)<{gradientNeed?: boolean, blackBG?: boolean}>`
    position: relative;
    align-items: center;
    
    &.country {
        flex-direction: column;
    }

    & + & {
        margin-top: 24px;
    }

    #account-id-input {
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &:after {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 2px;
        width: 97px;
        z-index: 2;
        height: 45px;
        background: ${p => p?.blackBG ? 'linear-gradient(270deg, rgba(197,198,199,0.9) 55% , rgba(197,198,199,0) 100%);' : 'linear-gradient(270deg, rgba(242,242,242,0.9) 55.21%, rgba(242, 242, 242, 0) 100%);'};
        display: ${p => p?.gradientNeed ? 'inline-block': 'none'};
    }

    @media(max-width: ${LayoutConst.screen.s -1 }px) {
        height: auto;
        & + & {
            margin-top: 16px;
        }
    
    }
`;

export const CountriesListDropdown = styled.div< {isGeograffee?: boolean}>`
  display: flex;
  flex-direction: column;
  max-height: 184px;
  width: calc(100% - 174px - 24px);
  right: 0;
  top: calc(100% - 1px);
  z-index: 10000;
//   border-bottom: 1px solid #fefefe;
  box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.12);
  background: ${({ isGeograffee }) => (isGeograffee ? '#3F4548' : '#F2F2F2')};  
  overflow-y: auto;
  color: ${({ isGeograffee }) => (isGeograffee ? '#ABAEAF' : '#000')};
//   height: 184px;
  height: fit-content;
  position: absolute;

  &:hover{
  }

  &::-webkit-scrollbar {
    width: 6px; /* ширина scrollbar */
    height: 10px;
  }
  &::-webkit-scrollbar-track {
    background: ${({ isGeograffee }) => (isGeograffee ? '#3F4548' : '#CDCDCD')};  /* цвет дорожки */
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 3px; /* закругления плашки */
    background: #909090;
  }
  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    top: calc(100% - 8px);
    width: calc(100% - 174px - 4px);
  }
  @media(max-width: ${LayoutConst.screen.s - 1}px) {
    top: 100%;
    width: 100%;
  }
`

export const CountryItem = styled.div< {isGeograffee?: boolean}>`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
  font-size: 17px;
  line-height: 22px;
  font-weight: 600;
//   background: #F2F2F2;
  padding: 12px 16px;
  cursor: pointer;
  img {
    width: 24px;
    height: 15px;
  }
  @media (max-width: 1200px) {
    font-size: 15px;
    line-height: 20px;
    padding: 8px 16px;
  }
  &:hover {
        background: ${({ isGeograffee }) => (isGeograffee ? '#575B5E' : '#ededed')};  
        color: ${({ isGeograffee }) => (isGeograffee ? '#ABAEAF' : '#000')};
  }
`

export const CopyIconWrapper = styled(FlexBox)`
    position: absolute;
    top:50%;
    transform: translateY(-50%);
    right: 16px;
    z-index: 3;
    width: 97px;
    justify-content: flex-end;
    // &:hover {
    //     svg path {
    //         fill: ${p => p?.theme.designerEdit.icons.colorHover};
    //         transition: 0.2s fill;
    //     }
    // }
`;

export const ShareIconWrapper = styled(FlexBox)`
    position: absolute;
    bottom: 16px;
    right: 16px;

    &:hover {
        svg path {
            fill: ${p => p?.theme.designerEdit.icons.colorHover};
            transition: 0.2s fill;
        }
    }
`;

export const PasswordChangeLabel = styled(FlexBox)`
    svg {
        height: 20px;
        height: 20px;
    }
`;

export const DesignerInputLabel = styled(FInter.SmallTextDiv)<{ whiteLabel?: boolean, importantColor?: boolean }>`
    font-size: 17px;
    line-height: 22px;
    width: 174px;
    min-width: 174px;
    margin-right: 24px;
    color: ${(p) => p?.whiteLabel ? p.theme.designerEdit.inputs.whiteLabelColor: p.theme.designerEdit.inputs.labelColor};


    ${p => p.importantColor ? css`
    color: ${(p) => p.theme.designerEdit.inputs.importantColor};
    ` : null}

    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        width: 154px;
        min-width: 154px;
        font-size: 15px;
        line-height: 20px;
    }

    @media(max-width: ${LayoutConst.screen.s -1 }px) {
        width: calc(100% - 20px);
        min-width: calc(100% - 20px);
        margin-bottom: 12px;
    }
`;


export const AvatarLabel = styled(FlexBox)`
    width: 174px;
    min-width: 174px;
    margin-right: 24px;

    ${DesignerInputLabel} {
        font-size: 17px;
        line-height: 22px;
    }

    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        width: 154px;
        min-width: 154px;

        ${DesignerInputLabel} {
            font-size: 15px;
            line-height: 20px;
        }
    }
`;

export const DesignerResizeBlock = styled.div<{ withoutBorder?: boolean, col?: boolean }>`
    display: flex;
    flex-flow: ${({ col }) => col ? 'column' : 'row'};
    margin-top: 24px;
    place-items: baseline;

    textarea {
        max-height: 500px;
        width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.s -1 }px) {
        margin-top: 16px;
    }
`;
 
export const DesignerEditAboutProfile = styled(FlexBox)`
    /* background-color: #262c30; */
    background: ${(p) => p.theme.designerEdit.aboutProfile.bg};
    padding: 24px;
    border-radius: 8px;
    width: 560px;
`;

export const DesignerMergeAccounts = styled(FlexBox)`
    background: ${(p) => p.theme.designerEdit.aboutProfile.bg};
    padding: 14px;
    border-radius: 8px;
    width: 560px;
    flex-direction: column;
`;

/* потом переписать! костыль! */
interface IActiveWhiteTheme extends IActively {
    custom_theme?: boolean;
    white_theme?: boolean;
}

export const DesignerLocalSwitchItem = styled(FInter.TextBoldDiv)<IActiveWhiteTheme>`
    cursor: pointer;
    color: ${(p) =>
        p.active ? p.theme.designerEdit.localSwitch.textColor : p.theme.designerEdit.localSwitch.textColorInactive};
    padding-bottom: ${(p) => (p.active ? 4 : 6)}px;
    border-bottom: ${(p) => (p.active ? `2px solid ${p.theme.designerEdit.localSwitch.borderColor}` : 'none')};

    & + & {
        margin-left: 24px;
    }

    &:hover {
        color: ${(p) =>
            p.active ? p.theme.designerEdit.localSwitch.textColor : p.theme.designerEdit.localSwitch.textColorHover};
    }
`;

export const DesignerSidebarContainer = styled(FlexBox)`
    width: 270px;
    margin-top: 49px;
    position: relative;
`;
export const DesignerSidebarContent = styled(FlexBox)`
    width: 270px;
    flex-direction: column;
    position: fixed;
    top: calc(64px + 49px);
    bottom: 65px;
`;

export const DesignerEditPageLink = styled(FInter.SmallTextBoldFlex)<{ active?: boolean; className?: boolean }>`
    cursor: pointer;
    transition: all 0.2s;

    :hover {
        color: ${(p) => p.theme.designerEdit.pageLink.hoverColor};
    }

    & + & {
        margin-top: 20px;
    }
`;

export const LabelRedStar = styled(FInter.SmallText)<{ hide?: boolean }>`
    font-family: Inter;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -2%;

    margin-left: 4px;
    color: ${Colors.redFailed};

    ${p => p?.hide ? css` opacity: 0;` : null};
`;

export const LabelBigRedStar = styled(FInter.SmallText)`
    font-weight: 500;
    color: ${Colors.redFailed};
    position: absolute;
    top: 2px;
    right: -8px;
`;

export const PlaceholderImg = styled.img<any>`
width: ${p => p.width? p.width + 'px' : 'auto'};
height: ${p => p.height? p.height + 'px' : 'auto'};
padding: 5px;
`

export const WordCount = styled(FlexBox)`
    padding-top: 6px;
    width: 100%;
    justify-content: flex-end;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 13px;
    letter-spacing: 0.06em;
    color: ${({ theme }) => theme.designerEdit.inputs.labelColor};
`;

export const DeleteButtonIconWrapper = styled(FlexBox)`
    position: absolute;
    right: 10px;
    top: 10px;
    padding: 6px;
    z-index: 100;
    cursor: pointer;
    border-radius: 20%;

    background: rgba(24, 26, 28, 0.5);
    backdrop-filter: blur(2px);

    svg {
        margin-top: -2px;
    }
`;

export const ProfileTagsWrapper = styled(FlexBox)<{ isGeograffee?: boolean }>`
    color: ${(p) => p.isGeograffee && p.theme.tagItemView.textColor};
`;

export const ProfileTagsLabel = styled(AvatarLabel)``;

export const InputLabel = styled(AvatarLabel)``;

export const ProfileTagsListWrapper = styled(FlexBox)`
    overflow-y: hidden;
    margin: 0;
    width: 100%;
    display: inline-flex;
    flex-wrap: wrap;
    position: relative;

`;

export const ChangePasswordButton = styled.div`
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    color: #E36650;
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    cursor: pointer;

    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }

    @media(max-width: ${LayoutConst.screen.s -1 }px) {
        top: auto;
        bottom: 0;
    }
`;

export const ForgetPasswordButton = styled(ChangePasswordButton)`
    bottom: -28px;
    top: auto;
    left: calc(174px + 24px);
    transform: none;

    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        left: calc(154px + 24px);
    }

    @media(max-width: ${LayoutConst.screen.s -1 }px) {
        left: 0px;
    }
`;

export const ButtonFilled = styled(RectangularButtonFilled)<{isLMS?: boolean}>`
    width: 200px;
    height: 38px;
    font-size: 17px;
    line-height: 22px;
    padding: 8px 24px;
    white-space: nowrap;
    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
        height: 36px;
        width: 176px;
        padding: 8px 20px;
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        height: 36px !important;
    }

    @media(max-width: ${LayoutConst.screen.s -1 }px) {
        width: ${({isLMS}) => isLMS ? 100 : 65}%;
        min-width: 65%;
        height: 36px !important;
    }
`;

export const QueueButtonFilled = styled(RectangularButtonFilled)<{ hide?: boolean}>`

    ${({ hide }) => hide && css`
        display: none;
    `};
  height: 46px !important;
  @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        height: 38px !important;
      font-weight: 700;
    }
    @media(max-width: ${LayoutConst.screen.m}px) {
        height: 36px !important;
    }
    @media(max-width: ${LayoutConst.screen.s -1 }px) {
        margin-top: 24px;
        width: 100%;
        min-width: 100%;
        height: 46px !important;
    }
`;

export const ButtonHollow= styled(RectangularButtonHollow)`
    width: 131px;
    min-width: 131px;
    height: 38px;
    font-size: 17px;
    line-height: 22px;
    padding: 8px 24px;
    white-space: nowrap;
    @media(max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 22px;
        height: 36px;
        width: 114px;
        min-width: 114px;
        padding: 8px 20px;
    }
    @media(max-width: ${LayoutConst.screen.m}px) {
        height: 36px !important;
    }

    @media(max-width: ${LayoutConst.screen.s -1 }px) {
        width: 100%;
        min-width: auto;
        height: 36px !important;
    }
`;

export const TwoWindowWrapper = styled.div`
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    // z-index: 1;
    // background-color: ${(p) => p.theme.designerEdit.aboutProfile.bg};
    background-color: transparent;

    @media(max-width: ${LayoutConst.screen.s -1 }px) {
        top: auto;
        transform: none;
        bottom: 12%;
    }
`;

export const SaveButton = styled(RectangularButtonHollow)`
  height: 40px !important;
  min-height: 32px;
  font-weight: 600 !important;
  min-width: auto !important;
  width: 108px !important;
  background-color: ${({ theme }) => theme.modal.buttons.saveButtonBG} !important;
  color: ${({ theme }) => theme.modal.buttons.saveButtonColor} !important;
  padding: 7px 12px 9px 12px;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.01em;
  text-align: left;

`;

export const ExitButton = styled.button`
  height: 40px !important;
  width: 74px;
  padding: 7px 12px 9px 12px;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.01em;
  text-align: left;
  border: none;
`;